import React from "react";

export const VehicleHiringEntryDetailContext = React.createContext(null);

export const useVehicleHiringEntryDetailContext = () => {
  const context = React.useContext(VehicleHiringEntryDetailContext);

  if (!context)
    throw new Error("Vehicle Hiring Entry Detail Context not provided!");

  return context;
};